module.exports = __webpack_public_path__ + "img/car@2x.eecc045a.png";